import { render, staticRenderFns } from "./IconCloseFat.vue?vue&type=template&id=41e85dd1&"
import script from "./IconCloseFat.vue?vue&type=script&lang=js&"
export * from "./IconCloseFat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports